<template>
  <div v-if="show" id="form_btn_container" class="text-[var(--text)] min-w-[40%] gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half">

    <div class="w-full flex justify-between">
      <h3 class="text-[var(--titulo)] text-[18px] font-bold">{{ form_title }}</h3>
      <div class="flex items-center gap-2">
        <HistoricoObjetoButton
          model-name="Viatura"
          :objeto-id="form_data.id"
          modelo-label="Viatura"
          variant="bare"
          icon-only
        />
        <AppButton
          style="color: var(--icon);"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>
    </div>

    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="input_container">
          <label for="matricula" class="input_label">Matricula:</label>
          <input
            type="text"
            :disabled="form_data.status == 'desativado'"
            v-model="form_data.matricula"
            placeholder="Matricula"
            class="w-full text-[20px] p-1 rounded-[5px]"
            :class="{ 'input-required': create_btn && !form_data.matricula }"
          />
        </div>

        <div class="input_container">
          <label for="marca" class="input_label">Marca:</label>
          <input
            type="text"
            :disabled="form_data.status == 'desativado'"
            v-model="form_data.marca"
            placeholder="Marca"
            class="w-full text-[20px] p-1 rounded-[5px]"
            :class="{ 'input-required': create_btn && !form_data.marca }"
          />
        </div>

        <div class="input_container">
          <label for="Modelo" class="input_label">Modelo:</label>
          <input
            type="text"
            :disabled="form_data.status == 'desativado'"
            v-model="form_data.modelo"
            placeholder="Modelo"
            class="w-full text-[20px] p-1 rounded-[5px]"
            :class="{ 'input-required': create_btn && !form_data.modelo }"
          />
        </div>
        <div class="data_set_class">
          <div class="grid grid-cols-[auto_1fr_min-content] gap-y-1 mr-6 items-center">
            <div class="ser_data">
              <label class="min-w-[76px] font-bold">Tipo Viatura:</label>
            </div>
            <div class="ser_data" :style="{ color: set_data.tipo_viatura.id === 0 ? 'var(--obrigatorio)' : 'var(--icon)' }">
              {{ set_data.tipo_viatura.nome || "Não Atribuído" }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' || !create_btn ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' || !create_btn"
                @click="open_dialog_alert('tpviatura')">
                <Icon class="edit-icon" icon="lucide:truck" />
              </button>
            </div>

            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Tecnico:</label>
            </div>
            <div v-if="!create_btn" :style="{ color: 'var(--icon)'}">
              {{ set_data.utilizador.user || "Não Atribuído" }}
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="open_dialog_alert('utilizador')">
                <Icon class="edit-icon" icon="lucide:user-cog" />
              </button>
            </div>

            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Armazem:</label>
            </div>
            <div v-if="!create_btn" class="mr-4" :style="{ color: 'var(--icon)'}">
              {{ set_data.armazem.nome || "Não Atribuído" }}
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' || !create_btn ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' || isArmazemOficinaOrViatura()"
                @click="selectTable('armazem')">
                <Icon class="edit-icon" icon="lucide:user-cog" />
              </button>
            </div>

            <div class="flex items-center">
              <label class="min-w-[76px] font-bold">GPS:</label>
            </div>
            <div :style="{ color: 'var(--icon)'}">
              {{ set_data.gps.nome || "Não Atribuído" }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="open_dialog_alert('gps')">
                <Icon class="edit-icon" icon="lucide:locate" />
              </button>
            </div>

            <!-- v0012 -->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Manutenção:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('manutencao')">
                <Icon class="edit-icon" icon="lucide:wrench" />
              </button>
            </div>

            <!-- v0013 -->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Artigos:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('stock')">
                <Icon class="edit-icon" icon="lucide:box" />
              </button>
            </div>

            <!-- v0014 "selectTable('stock')""-->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Consumos:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="avisoImplementacao">
                <Icon class="edit-icon" icon="mdi:gas-station" />
              </button>
            </div>

            <!-- v0015 "selectTable('portagens')""-->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Portagens:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="avisoImplementacao">
                <Icon class="edit-icon" icon="fa6-solid:hand-holding-dollar" />
              </button>
            </div>

            <!-- v0016 "selectTable('mapas')""-->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Mapas:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="avisoImplementacao">
                <Icon class="edit-icon" icon="lucide:map" />
              </button>
            </div>

            <!-- v0017 "selectTable('escalas')""-->
            <div v-if="!create_btn" class="flex items-center">
              <label class="min-w-[76px] font-bold">Escalas:</label>
            </div>
            <div v-if="!create_btn" class="ser_data w-[4px]"></div>
            <div v-if="!create_btn" class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="avisoImplementacao">
                <Icon class="edit-icon" icon="lucide:clipboard" />
              </button>
            </div>
        </div>
        </div>
      </div>

      <div id="right_form" class="right_form">
        <div class="img_container">
          <div class="img_btn_container">
            <div class="img_container">
              <img id="viatura_img" :src="form_data.foto" alt="viatura image" />
            </div>

            <div style="margin-top: 0.5rem">
              <label for="input-file">
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  :style="{
                    color:
                      form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',
                    cursor:
                      form_data.status == 'desativado'
                        ? 'not-allowed'
                        : 'pointer',
                  }"
                ></i>
              </label>
              <input
              style="color: var(--text); background-color: var(--label);"
                :disabled="form_data.status == 'desativado'"
                type="file"
                accept="image/*"
                id="input-file"
                @change="upload_img"
                hidden
              />
            </div>
          </div>
        </div>
        <div class="right_input_container">
          <div class="flex gap-4">
            <div style="display: flex">
              <label for="Mês" style="min-width: 5rem">Mês:</label>
              <input
                type="text"
                :disabled="form_data.status == 'desativado'"
                v-model="form_data.mes"
                placeholder="Mes"
                class="w-full text-[20px] p-1 rounded-[5px]"
                :class="{ 'input-required': create_btn && !form_data.mes }"
              />
            </div>
            <div style="display: flex">
              <label for="Ano" style="min-width: 5rem">Ano:</label>
              <input
                type="text"
                :disabled="form_data.status == 'desativado'"
                v-model="form_data.ano"
                placeholder="Ano"
                class="w-full text-[20px] p-1 rounded-[5px]"
                :class="{ 'input-required': create_btn && !form_data.ano }"
              />
            </div>
          </div>

          <div style="display: flex; gap: 1rem">
            <div style="display: flex">
              <label for="Cor" style="min-width: 5rem">Cor:</label>
              <input
                type="text"
                :disabled="form_data.status == 'desativado'"
                v-model="form_data.cor"
                placeholder="Cor"
                class="w-full text-[20px] p-1 rounded-[5px]"
                :class="{ 'input-required': create_btn && !form_data.cor }"
              />
            </div>
            <div style="display: flex">
              <label for="volumetria" style="min-width: 5rem"
                >Volumetria:</label
              >
              <input
              style="color: var(--text); background-color: var(--label);"
                :disabled="form_data.status == 'desativado'"
                type="text"
                v-model="form_data.volumetria"
                placeholder="Volumetria"
                class="input_field"
              />
            </div>
          </div>

          <div style="display: flex; gap: 1rem">
            <div style="display: flex">
              <label for="kilometragem" style="min-width: 5rem">KM:</label>
              <input
              style="color: var(--text); background-color: var(--label);"
                :disabled="form_data.status == 'desativado'"
                type="text"
                v-model="form_data.km"
                placeholder="kilometragem"
                class="input_field"
              />
            </div>
            <div style="display: flex">
              <label for="kilimetragem_max" style="min-width: 5rem"
                >KM manu.:</label
              >
              <input
              style="color: var(--text); background-color: var(--label);"
                :disabled="form_data.status == 'desativado'"
                type="text"
                v-model="form_data.kmManutencao"
                placeholder="kilometragem máxima"
                class="input_field"
              />
            </div>
          </div>
          <div style="display: flex">
          <label style="min-width: 7rem">Observações:</label>
          <textarea
            :disabled="form_data.status == 'desativado'"
            v-model="form_data.observacao"
            placeholder="Observações"
            class="input_field textarea"
            style="resize: none; background-color: var(--label);"
            ></textarea>
          </div>

          <div style="display: flex">
            <label style="min-width: 7rem">Danos:</label>
            <textarea
              :disabled="form_data.status == 'desativado'"
              v-model="form_data.danos"
              placeholder="Danos"
              class="input_field textarea"
              style="resize: none; background-color: var(--label);"
            ></textarea>
          </div>
        </div>          
      </div>
    </div>

    <div class="flex gap-2 p-1">
      <button
        v-if="create_btn && this.validPermission('V0017')"
        class="btn"
        @click="showConfirm($event, 'create')"
        :font_size="14"
      >Criar</button>
      <button
        v-if="!create_btn && this.validPermission('V0018') && form_data.status === 'ativo'"
        class="btn"
        :style="{backgroundColor: 'rgb(0, 102, 152)',}"
        @click="showConfirm($event, 'update')"
        :font_size="14"
      >Atualizar</button>
      <button
        v-if="!create_btn && this.validPermission('V0021') && form_data.status ==='ativo' && form_data.oficina !== 'ativo' && form_data.manutencao !== 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'red' }" 
        @click="showConfirm($event, 'disable')">Desativar</button>
      <button
        v-if="!create_btn && this.validPermission('V0021') && form_data.status ==='desativado' && form_data.oficina !== 'ativo' && form_data.manutencao !== 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'disable')">Ativar</button>     
      <button
        v-if="!create_btn && this.validPermission('V0019') && form_data.status ==='ativo' && form_data.oficina !== 'ativo' && form_data.manutencao !== 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'gray' }" 
        @click="showConfirm($event, 'maintenance')">Enviar Para Manutenção</button>     
      <button
        v-if="!create_btn && this.validPermission('V0019') && form_data.status ==='ativo' && form_data.manutencao === 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'maintenance')">'Remover da Manutenção'</button>   
      <button
        v-if="!create_btn && this.validPermission('V0020') && form_data.status ==='ativo' && form_data.oficina !== 'ativo' && form_data.manutencao !== 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'gray' }" 
        @click="showConfirm($event, 'oficina')">Enviar Para Oficina</button>     
      <button
        v-if="!create_btn && this.validPermission('V0020') && form_data.status !=='desativado' && form_data.oficina === 'ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'oficina')">'Remover da Oficina'</button>   
    </div>   
    <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" :pagination="true" @returnData="handleReturnData" />
  </div>
</template>

<script>
import axios from "axios";
import AppButton from "@/components/updated/button.vue";
import { reactive } from "vue";
import { ref } from "vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import permissionMixin from "@/permissionMixin.js";
import Dialog from '@/components/dialog/dinamicDialog.vue';
import { toast } from "vue3-toastify";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";


export default {
  mixins: [permissionMixin],
  name: "AppUserForm",
  components: {
    AppButton,
    ConfirmPopUp,
    Dialog,
    HistoricoObjetoButton,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {

      baseURl: process.env.VUE_APP_URL_BASE,
      showDialog: false,
      dialogProps: {
        entity: ['cliente'],
        sideBar: true,
        multi: false,
        queryParams: {},
        specialQuery: {},
      },
      emit_type: "",
    };
  },


  methods: {
    open_dialog_alert(key) {
      if (key == "tpviatura") {
          this.dialogProps.entity[0] = "tpviatura";
          this.currentType = "tpviatura";
          this.dialogProps.title = "tpviatura";
          this.showDialog = true;
      } else if (key == "utilizador") {
          this.dialogProps.entity[0] = "semviatura";
          this.currentType = "utilizador";
          this.dialogProps.title = "utilizador";
          this.showDialog = true;
      } else if (key == "gps") {
          this.dialogProps.entity[0] = "gpssemviatura";
          this.currentType = "gps";
          this.dialogProps.title = "gps";
          this.showDialog = true;
      }
     },   

      handleReturnData(data) {
            console.log("Returned data:", data);
            if (data.tpviatura) {
              this.set_data.tipo_viatura=data.tpviatura
            } else if (data.utilizador) {
              this.set_data.utilizador=data.utilizador      
            } else if (data.gps) {
              this.set_data.gps=data.gps
            }     
        },

      closeDialog() {
          this.showDialog = false;
      },

    isArmazemOficinaOrViatura() {
      return (
        this.set_data?.tipo_viatura?.nome === "Armazem" ||
        this.set_data?.tipo_viatura?.nome === "Oficina-Armazem"
      );
    },

    avisoImplementacao()
    {
      toast("Em Implementação")
    },

    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },

    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        this.update();
      } else if (this.emit_type == "disable") {
        this.disable();
      } else if (this.emit_type == "maintenance") {
        this.addMaintenance();
      } else if (this.emit_type == "oficina") {
        this.addOficina();
      } else {
        this.$emit("show_table", this.emit_type);
      }

      console.log("Confirmed!");
    },

    selectTable(name) {
      console.log("select:", name);
      this.$emit("show_table", name);
    },

    async upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("viatura_img");
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);

        const payload = new FormData();
        payload.append("foto", file);
        this.form_data.newFoto = payload;

      }
    },

    create() {
      if (!this.isValidForm()) return;

      const payload = this.getFormData();
      this.$emit("create", payload);
    },
    update() {
      if (!this.isValidForm()) return;

      const payload = this.getFormData();
      this.$emit("update", payload);
    },

    addMaintenance() {
      const payload = this.getFormData();
      console.log("maintenance formdata:", payload);
      this.$emit("maintenance", payload);
    },
    addOficina() {
      const payload = this.getFormData();
      console.log("oficina formdata:", payload);
      this.$emit("add_oficina", payload);
    },
    disable() {
      const payload = this.getFormData();
      this.$emit("disable", payload);
    },
    isValidForm() {
      if (
        !this.form_data.matricula ||
        !this.form_data.marca ||
        !this.form_data.modelo ||
        !this.form_data.mes ||
        !this.form_data.ano ||
        !this.form_data.cor ||
        this.set_data.tipo_viatura.id == 0
      ) {
        toast("Preencha todos os campos obrigatórios!", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      return true;
    },

    getFormData() {
      const formDataObject = {
        ...this.form_data,
        ...this.set_data,
      };

      return formDataObject;
    },

    close() {
      this.$emit("close");
    },

    isEmptyField(field) {
      if (["matricula", "marca", "modelo", "tipo_viatura", "ano", "mes", "cor"].includes(field)) {
        return (
          this.form_data[field] === "" || Array.isArray(this.form_data[field])
        );
      }
      return false;
    },
  },


  watch: {
    form_data: {
      handler() {
        //this.isEmptyContactField()
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>

.form_container {
  display: flex;
  gap: 1px;
  padding: 1px;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: var(--label);
}

label {
  display: block;
  color: var(--label);
  /* font-weight: bold; */
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
select {
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--glass-border);
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}


.input_field.textarea {
  width: 200px;
  height: 80px;
  color: var(--text);
}

.data_set_class {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.data_set {
  font-size: 14px;
  color: var(--label);
  display: flex;
  gap: 0.3rem;
}

.right_form {
  display: flex;
  flex-direction: column;
  padding: 2px;
  align-items: center;
}

.img_container {
  margin-top: -0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.right_input_container {
  margin-top: 4px;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 10px;
  padding-left: 10px;
}


.set_data_container {
  display: flex;
  flex-direction: column; /* Organiza os itens verticalmente */
  gap: 1rem; /* Espaçamento entre os campos */
  background-color: var(--fundoComponente); /* Mesma cor de fundo */
  padding: 1rem; /* Espaçamento interno */
  border-radius: 10px; /* Bordas arredondadas */
  max-width: 100%; /* Para garantir que não ultrapasse a largura disponível */
}

.input_container {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 100px;
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--fundoApp);
}

.ser_data {
  display: flex;
  align-items: center; /* Alinha o texto verticalmente ao centro */
  justify-content: space-between; /* Espaça os rótulos e valores */
  gap: 0.5rem; /* Espaçamento entre os itens */
}

.ser_data label {
  min-width: 120px; /* Define uma largura mínima fixa para os rótulos */
  text-align: left; /* Alinha os rótulos à esquerda */
  font-weight: bold; /* Destaca os rótulos */
  color: var(--label); /* Cor branca para os rótulos */
}


.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}

</style>
